<!-- <head>
    <link rel="stylesheet" type="text/css" href="https://npmcdn.com/flatpickr/dist/themes/airbnb.css">
</head> -->

<!-- <link rel="stylesheet" href=".../flatpickr.min.css">
<script src=".../flatpickr.min.js"></script> -->
<form [formGroup]="patientIDLoginFg">
    <app-bootstrap-input [inputConfig]="patientIDConfig" (keypress)="patientid($event)"></app-bootstrap-input>

    <div
        class="form-group"
        [class.has-error]="patientIDLoginFg.get('DOB').invalid && patientIDLoginFg.get('DOB').touched"
    >
        <label for="dobP" class="control-label">Date of Birth</label>
        <div
            class="input-group"
            [ngClass]="{
                'border-style':
                    (onFocus && patientIDLoginFg.get('DOB').untouched) ||
                    (onFocus && patientIDLoginFg.get('DOB').dirty),
                'border-style-checkIcon': checkIcon,
                'border-style-error':
                    patientIDLoginFg.get('DOB').invalid && patientIDLoginFg.get('DOB').touched && dateErrorPresent
            }"
        >
            <input
                id="dobP"
                class="form-control input-date-picker default-cursor"
                placeholder="mm/dd/yyyy"
                type="text"
                mwlFlatpickr
                [dateFormat]="'m/d/Y'"
                [clickOpens]="false"
                [allowInput]="true"
                #dobPicker
                [disableMobile]="true"
                [maxDate]="maxDate"
                [minDate]="minDate"
                (flatpickrOpen)="onOpenDatePicker()"
                (flatpickrValueUpdate)="inputValueUpdated()"
                (flatpickrClose)="onCloseDatePicker()"
                lang="en"
                formControlName="DOB"
                autocomplete="off"
                mask="00/00/0000"
                (focus)="focus()"
                (blur)="blur()"
            />
            <span
                class="input-group-addon"
                (click)="openDatePicker($event)"
                [ngClass]="{ 'datepicker-bg-color-valid': checkIcon }"
            >
                <i class="glyphicon glyphicon-calendar"></i>
            </span>
            <span class="input-group-addon" *ngIf="checkIcon" [ngClass]="{ 'datepicker-bg-color-valid': checkIcon }">
                <i class="glyphicon glyphicon-ok" [ngClass]="{ checkIcon: checkIcon }"></i>
            </span>
        </div>
        <div *ngIf="patientIDLoginFg.get('DOB').invalid && patientIDLoginFg.get('DOB').touched" class="margin-top">
            <div
                class="formio-errors invalid-feedback"
                *ngIf="patientIDLoginFg.get('DOB').errors['pattern'] || patientIDLoginFg.get('DOB').errors['required']"
            >
                <p class="help-block">{{ errors.DATE_OF_BIRTH.FORMAT }}</p>
            </div>
        </div>
        <div *ngIf="patientIDLoginFg.get('DOB').invalid && patientIDLoginFg.get('DOB').touched">
            <div class="formio-errors invalid-feedback" *ngIf="patientIDLoginFg.get('DOB').errors['required']">
                <p class="help-block">{{ errors.DATE_OF_BIRTH.REQUIRED }}</p>
            </div>
        </div>

        <div
            *ngIf="onFocus && !(patientIDLoginFg.get('DOB').invalid && patientIDLoginFg.get('DOB').touched)"
            class="margin-top"
            style="font-style: italic"
            [ngStyle]="{ color: checkIcon === true ? 'green' : '#20a8d8' }"
            [ngClass]="{
                errorIcon:
                    patientIDLoginFg.get('DOB').invalid && patientIDLoginFg.get('DOB').touched && dateErrorPresent
            }"
        >
            Month, Day, Year
        </div>
    </div>
</form>
